import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateExamWithTestsDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface Props {
  handleFormData?: (input: string) => (s: string | boolean | Date) => void;
  neurologist?: boolean | null | undefined;
  ophthalmologist?: boolean | null | undefined;
  laryngologist?: boolean | null | undefined;
  psychiatrist?: boolean | null | undefined;
  psychologistConsultation?: boolean | null | undefined;
  propertyChange?: (obj: Partial<CreateUpdateExamWithTestsDto>) => void;
}

export const AddExamConsultations: React.FC<Props> = ({
  handleFormData,
  neurologist,
  ophthalmologist,
  laryngologist,
  psychiatrist,
  psychologistConsultation,
  propertyChange,
}) => {
  const propertyNeurologistChange = (neu: boolean) => {
    if (handleFormData) {
      handleFormData('neurologist')(neu);
    }
    if (propertyChange) {
      propertyChange({ neurologist: neu });
    }
  };

  const propertyOphthalmologistChange = (opt: boolean) => {
    if (handleFormData) {
      handleFormData('ophthalmologist')(opt);
    }
    if (propertyChange) {
      propertyChange({ ophthalmologist: opt });
    }
  };

  const propertyLaryngologistChange = (lar: boolean) => {
    if (handleFormData) {
      handleFormData('laryngologist')(lar);
    }
    if (propertyChange) {
      propertyChange({ laryngologist: lar });
    }
  };

  const propertyPsychiatristChange = (ps: boolean) => {
    if (handleFormData) {
      handleFormData('psychiatrist')(ps);
    }
    if (propertyChange) {
      propertyChange({ psychiatrist: ps });
    }
  };

  const propertyPsychologistConsultationChange = (ps: boolean) => {
    if (handleFormData) {
      handleFormData('psychologistConsultation')(ps);
    }
    if (propertyChange) {
      propertyChange({ psychologistConsultation: ps });
    }
  };

  return (
    <FormRow controlId="exam_consultations" label="Wymagany specjalista">
      <Form.Check
        label="Neurolog"
        type="checkbox"
        checked={neurologist ? true : false}
        onChange={e => propertyNeurologistChange(e.target.checked)}
      />
      <Form.Check
        label="Okulista"
        type="checkbox"
        checked={ophthalmologist ? true : false}
        onChange={e => propertyOphthalmologistChange(e.target.checked)}
      />
      <Form.Check
        label="Laryngolog"
        type="checkbox"
        checked={laryngologist ? true : false}
        onChange={e => propertyLaryngologistChange(e.target.checked)}
      />
      <Form.Check
        label="Psychiatra"
        type="checkbox"
        checked={psychiatrist ? true : false}
        onChange={e => propertyPsychiatristChange(e.target.checked)}
      />
      <Form.Check
        label="Psycholog"
        type="checkbox"
        checked={psychologistConsultation ? true : false}
        onChange={e => propertyPsychologistConsultationChange(e.target.checked)}
      />
    </FormRow>
  );
};
